import React from 'react';
import { FormattedMessage, useIntl, defineMessages } from 'react-intl-next';

import { fireOperationalAnalytics } from '@atlassian/analytics-bridge';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { Text } from '@atlaskit/primitives/compiled';

import messages from '../../messages';
import type { LastUpdated } from '../../types';

const lastUpdatedMessages = defineMessages({
	created: {
		id: 'confluence-table-tree.friendly-when-created',
		defaultMessage: 'Created',
		description: 'Displayed next to a timestamp to indicate when a page was first created',
	},
	updated: {
		id: 'confluence-table-tree.friendly-when-updated',
		defaultMessage: 'Updated',
		description: 'Displayed next to a timestamp to indicate when a page was last updated',
	},
});

export const LastUpdatedBase = ({ lastUpdated }: { lastUpdated?: LastUpdated }) => {
	const { formatMessage } = useIntl();
	const { createAnalyticsEvent } = useAnalyticsEvents();
	if (!lastUpdated) {
		fireOperationalAnalytics(createAnalyticsEvent({}), 'confluencePageTree unknownContributor');

		return (
			<small>
				<FormattedMessage {...messages.couldNotLoad} />
			</small>
		);
	}
	const { friendlyWhen, number } = lastUpdated;
	const prefix = number === 1 ? lastUpdatedMessages.created : lastUpdatedMessages.updated;
	return (
		<Text size="small">
			{formatMessage(prefix)} {friendlyWhen}
		</Text>
	);
};

export default LastUpdatedBase;
